import Swiper, {
	Autoplay,
	EffectFade,
	Grid,
	Navigation,
	Pagination,
	Thumbs,
} from "swiper";
/**
 * @param swiperInit
 */
export default function swiperInit() {
	var homeBanner = new Swiper(`.home-banner-swiper .swiper`, {
		modules: [Autoplay, Pagination],
		slidesPerView: 1,
		autoplay: {
			delay: 5000,
		},
		pagination: {
			el: `.home-banner-swiper .swiper-pagination`,
			type: "bullets",
			clickable: true,
		},
	});

	var home4 = new Swiper(`.home-4-swiper .swiper`, {
		modules: [Autoplay, Navigation, Pagination],
		slidesPerView: 2,
		spaceBetween: 15,
		autoplay: {
			delay: 5000,
		},
		pagination: {
			el: `.home-4-swiper .swiper-pagination`,
			type: "bullets",
			clickable: true,
			dynamicBullets: true,
		},
		navigation: {
			prevEl: `.home-4-swiper .btn-prev`,
			nextEl: `.home-4-swiper .btn-next`,
		},
		breakpoints: {
			768: {
				slidesPerView: 3,
			},
			1024: {
				slidesPerView: 4,
				spaceBetween: 32,
			},
		},
	});

	var about6 = new Swiper(`.about-6-swiper .swiper`, {
		modules: [Autoplay, Navigation, Pagination],
		slidesPerView: 2,
		spaceBetween: 15,
		autoplay: {
			delay: 5000,
		},
		pagination: {
			el: `.about-6-swiper .swiper-pagination`,
			type: "bullets",
			clickable: true,
			dynamicBullets: true,
		},
		navigation: {
			prevEl: `.about-6-swiper .btn-prev`,
			nextEl: `.about-6-swiper .btn-next`,
		},
		breakpoints: {
			768: {
				slidesPerView: 3,
			},
			1024: {
				slidesPerView: 4,
				spaceBetween: 32,
			},
		},
	});

	var fieldOfActivityList = new Swiper(
		`.field-of-activity-list .section-swiper .swiper`,
		{
			modules: [Autoplay, Navigation, Pagination],
			slidesPerView: 1.8,
			spaceBetween: 15,
			centeredSlides: true,
			loop: true,
			pagination: {
				el: `.field-of-activity-list .section-swiper .swiper-pagination`,
				type: "bullets",
				clickable: true,
				dynamicBullets: true,
			},
			navigation: {
				prevEl: `.field-of-activity-list .section-swiper .btn-prev`,
				nextEl: `.field-of-activity-list .section-swiper .btn-next`,
			},
			breakpoints: {
				768: {
					spaceBetween: 32,
				},
			},
		}
	);

	var fieldOfActivityDetailThumb = new Swiper(
		`.field-of-activity-detail .swiper-thumb .swiper`,
		{
			modules: [Pagination],
			slidesPerView: 3,
			spaceBetween: 10,
			breakpoints: {
				768: {
					slidesPerView: 4,
					spaceBetween: 20,
				},
			},
			pagination: {
				el: `.field-of-activity-detail .section-detail .swiper-pagination`,
				type: "bullets",
				clickable: true,
				dynamicBullets: true,
			},
		}
	);

	var fieldOfActivityDetailMain = new Swiper(
		`.field-of-activity-detail .swiper-main .swiper`,
		{
			modules: [Thumbs, Navigation, Pagination],
			slidesPerView: 1,
			thumbs: {
				swiper: fieldOfActivityDetailThumb,
			},
			navigation: {
				prevEl: `.field-of-activity-detail .section-detail .btn-prev`,
				nextEl: `.field-of-activity-detail .section-detail .btn-next`,
			},
		}
	);

	var fieldOfActivityRelated = new Swiper(
		`.field-of-activity-detail .section-related .swiper`,
		{
			modules: [Navigation, Pagination],
			slidesPerView: 2,
			spaceBetween: 15,
			pagination: {
				el: `.field-of-activity-detail .section-related .swiper-pagination`,
				type: "bullets",
				clickable: true,
				dynamicBullets: true,
			},
			navigation: {
				prevEl: `.field-of-activity-detail .section-related .btn-prev`,
				nextEl: `.field-of-activity-detail .section-related .btn-next`,
			},
			breakpoints: {
				768: {
					slidesPerView: 3,
					spaceBetween: 15,
				},
				1024: {
					slidesPerView: 3,
					spaceBetween: 32,
				},
			},
		}
	);

	var member_detail = new Swiper(`.meber-detail .swiper`, {
		modules: [Navigation],
		slidesPerView: 1,
		navigation: {
			prevEl: `.meber-detail .btn-prev`,
			nextEl: `.meber-detail .btn-next`,
		},
	});
}
